import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
let stripePromise
const getStripe = () => {
  if (!stripePromise) {
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
  }
  return stripePromise
}
const StripeConfig = ({ children }) => {
  return (
    <Elements
      stripe={getStripe()} options={{
        mode: 'payment',
        currency: 'usd',
        amount: 1000
      }}
    >
      {children}
    </Elements>
  )
}

export default StripeConfig
